module.exports = __webpack_public_path__ + "menu_bullet.png?67b1adb29c1fd78770592bbeb4b1805d";


//////////////////
// WEBPACK FOOTER
// ./images/menu_bullet.png
// module id = 163
// module chunks = 0